// extracted by mini-css-extract-plugin
export default {"existingItem":"AnnotationLayer_existingItem__hC3y9","addNewItem":"AnnotationLayer_addNewItem__m3JII"};